<template>
  <!-- 加载状态 -->
  <el-empty v-if="isLoading" description="加载中...">
    <el-icon class="is-loading"><loading /></el-icon>
  </el-empty>
  <!-- 无数据状态 -->
  <el-empty v-else-if="articles.length === 0" description="暂无文章">
    <el-icon><document /></el-icon>
  </el-empty>
  <!-- 文章列表 -->
  <el-row :gutter="12" v-else>
    <el-col
      :xs="24"
      :sm="12"
      :md="8"
      :lg="6"
      :xl="6"
      v-for="article in articles"
      :key="article.ID"
    >
      <el-card
        shadow="hover"
        class="article-item"
        @click="handleArticleClick(article)"
      >
        <!-- 文章标题（卡片头部） -->
        <template #header>
          <h2>{{ article.Title }}</h2>
        </template>
        <!-- 文章摘要 -->
        <p class="summary">{{ article.ZhaiYao }}</p>
        <!-- 元信息 -->
        <div class="meta">
          <span class="create-time">{{ formatCreateTime(article.CreateTime) }}</span>
          <span
            class="type"
            :style="{ color: getTypeColor(article.Type) }"
          >
            {{ getTypeLabel(article.Type) }}
          </span>
        </div>
        <!-- 图片列表 -->
        <div class="images" v-if="article.img?.List?.length">
          <img
            v-for="(img, index) in article.img.List.slice(0, 3)"
            :key="index"
            :src="img"
            :alt="`Article Image ${index + 1}`"
            loading="lazy"
          />
          <div v-if="article.img.List.length > 3" class="more-images">
            +{{ article.img.List.length - 3 }}
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>

  <!-- 使用组件 -->
  <MobileIframeViewer
    v-if="showIframe"
    :show-iframe="showIframe"
    :iframe-src="iframeSrc"
    @close="closeIframe"
  />
</template>

<script>
import axios from 'axios';
import { Loading, Document } from '@element-plus/icons-vue';
import MobileIframeViewer from '@/components/MobileIframeViewer.vue';

export default {
  components: {
    Loading,
    Document,
    MobileIframeViewer
  },
  data() {
    return {
      articles: [],
      isLoading: true,
      showIframe: false,
      iframeSrc: '',
      loading: false
    };
  },
  methods: {
    // 文章列表获取
    async fetchArticles() {
      try {
        const response = await axios.get('/api/article_list');
        if (response.data.MsgTop?.List) {
          this.articles = response.data.MsgTop.List;
        }
      } catch (error) {
        console.error('获取文章列表失败', error);
      } finally {
        this.isLoading = false;
      }
    },
    // 时间格式化
    formatCreateTime(timestamp) {
      const date = new Date(parseInt(timestamp) * 1000);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    // 类型颜色映射
    getTypeColor(type) {
      switch (type) {
        case '2': return 'blue';
        case '5': return 'green';
        case '9': return 'orange';
        case '13': return 'purple';
        default: return 'gray';
      }
    },
    // 类型标签映射
    getTypeLabel(type) {
      switch (type) {
        case '2': return '新闻';
        case '5': return '公告';
        case '9': return '复盘';
        case '13': return '专题';
        default: return '其他';
      }
    },
    handleArticleClick(article) {
      let url;
      if (article.TopicID) {
        // 移动端直接跳转到外部链接
        if (this.isMobile()) {
          window.location.href = `https://apppage.longhuvip.com/w383/share/PContent2.html?AID=${article.TopicID};${article.IsShowStyle};${article.IsEditContent}`;
          return;
        }
        url = `https://apppage.longhuvip.com/w383/share/PContent2.html?AID=${article.TopicID};${article.IsShowStyle};${article.IsEditContent}`;
      } else {
        url = `/article_detail?MsgID=${article.ID}`;
      }
      this.openInIframe(url);
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    openInIframe(url) {
      if (url) {
        this.iframeSrc = url;
        this.showIframe = true;
      }
    },
    closeIframe() {
      this.showIframe = false;
      this.iframeSrc = '';
    },
  },
  mounted() {
    this.fetchArticles();
  }
};
</script>

<style scoped>
.article-item {
  max-height: 450px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: transform 0.2s;
}

.article-item:hover {
  transform: translateY(-2px);
}

.article-item h2 {
  margin: 0 0 8px 0;
  font-size: 16px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.summary {
  color: #555;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
}

.create-time {
  color: #888;
}

.type {
  font-weight: bold;
}

.images {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
}

.images img {
  width: calc(50% - 2px);
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}

.more-images {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.1);
  border-radius: 4px;
  font-size: 12px;
  color: #666;
  min-width: 50px;
}

/* 移动端特殊优化 */
@media (max-width: 768px) {
  .article-item {
    margin-bottom: 10px;
  }

  .article-item h2 {
    font-size: 15px;
  }

  .summary {
    font-size: 13px;
  }

  .meta {
    font-size: 11px;
  }

  .images img {
    width: 100%;
  }

  .article-item:hover {
    transform: none;
  }
}
</style>
